import { useContext } from 'react';
import Header from './Header';
import Footer from './Footer';
import { ThemeContext } from '../../context/ThemeContext';

const Layout = ({ children }) => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <div className={`min-h-screen flex flex-col ${darkMode ? 'dark bg-secondary-900' : 'bg-white'}`}>
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;